import { Injectable, PLATFORM_ID, inject, signal, computed } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { makeStateKey, TransferState, REQUEST_CONTEXT } from '@angular/core';

import { ISection } from '../models/documents.model';

const US_STATE_KEY = makeStateKey<string>('US_STATE_CODE');

@Injectable({ providedIn: 'root' })
export class StateService {
    readonly stateCode: ReturnType<typeof signal<string>>;
    readonly showSelectState: ReturnType<typeof computed<boolean>>;
    readonly isOrderPage = signal<boolean>(false);
    readonly sidebarSection = signal<ISection | null>(null);
    readonly hasSidebar = computed(() => !!this.sidebarSection());

    constructor() {
        const platformId = inject(PLATFORM_ID);
        const transferState = inject(TransferState);

        let initialCode = '';

        if (isPlatformServer(platformId)) {
            const ctx = inject(REQUEST_CONTEXT, { optional: true }) as { userState?: string } | null;
            const code = ctx?.userState ?? '';
            
            if (code && code !== 'default') {
                initialCode = code;
                transferState.set(US_STATE_KEY, code);
            }
        } else {
            initialCode = transferState.get(US_STATE_KEY, '');
        }
        
        this.stateCode = signal<string>(initialCode);
        this.showSelectState = computed(() => this.stateCode() === 'select');
    }

    set(code: string): void {
        this.stateCode.set(code.toLowerCase());
    }
}
